import React from "react";
import StageBookViewer from "../components/StageBookViewer";
import { META, CHAPTERS } from "../data/ks3_book";

export default function Ks3BookViewer() {
  return (
    <StageBookViewer
      meta={META}
      chapters={CHAPTERS}
      accent="#5B8C5A"
      testIdPrefix="ks3"
      comingSoonNote="9 further chapters are in development for Key Stage 3 — Ethics & Society and Justice & Reform units."
    />
  );
}
